<template>
    <div>
        <router-link v-for="(item, index) in navItems" :key="index" :to="resolveRoute(item)" class="bottom-nav-item"
            exact-active-class="active" :class="{ active: isActive(item) }">
            <div class="icon-wrapper"><span :class="[
                'mdi',
                item.icon,
                'nav-icon',
            ]"></span>
                <span v-if="item.badge && cartCount > 0" class="bottom-nav-badge">
                    {{ cartCount }}
                </span>
            </div>
            <span>{{ $t(item.label) }}</span>
        </router-link>
    </div>
</template>


<script>
import config from "@/config";

export default {
    name: "BottomNav",
    data() {
        return {
            storageUrl: config.storageUrl,
            unreadCount: 0,
            cartCount: 0,
            navItems: [
                {
                    label: "main.home",
                    route: { name: "index" },
                    icon: "mdi-home",
                },
                {
                    label: "auth.account",
                    route: { name: "account" },
                    authRequired: true,
                    icon: "mdi-account",
                },
                {
                    label: "action.submit",
                    route: { name: "productSell" },
                    authRequired: true,
                    badge: true,
                    icon: "mdi-plus-circle",
                },
                {
                    label: "sentence.transactions",
                    route: { name: "myOperations" },
                    authRequired: true,
                    icon: "mdi-shopping",
                },
                {
                    label: "menu.dashboard",
                    route: { name: "dashboardBase" },
                    authRequired: true,
                    icon: "mdi-view-dashboard",
                },
            ],
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        resolveRoute(item) {
            if (item.authRequired&&(!this.user||!this.isLoggedIn)) {
                return { name: "login" };
            }
            return item.route;
        },
        isActive(item) {
            return this.$route.name===item.route.name;
        }

    },
};
</script>

<style scoped>
.bottom-nav-item:hover,
.bottom-nav-item.router-link-active {
    transform: translateY(-2px);
    color: var(--color-6);
}



.bottom-nav-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 8px 0;
    color: var(--color-6);
    font-size: 10px;
    text-decoration: none;
    position: relative;
    transition: all 0.2s ease;
}


.bottom-nav-item:hover,
.bottom-nav-item.router-link-active {
    transform: translateY(-2px);
}

.icon-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bottom-nav-badge {
    position: absolute;
    top: -4px;
    right: -8px;
    background: var(--color-6);
    color: white;
    border-radius: 10px;
    padding: 2px 6px;
    font-size: 9px;
    font-weight: 700;
    min-width: 18px;
    text-align: center;
}

@media (max-width: 767px) {


    main {
        padding-bottom: 70px;
    }

    .bottom-nav-item.active {
        color: var(--color-nz);
    }



    .bottom-nav-item.active .nav-icon {
        color: var(--color-nz);
    }

}

@media (min-width: 768px) {

}
</style>
